import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiConditionsSectionDTO,
  ConditionsSectionDTO,
} from "@lib/strapi/dtos/components/sections/conditionsSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class ConditionsSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiConditionsSectionDTO,
  ): Promise<ConditionsSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new ConditionsSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.layout = strapiData.layout;
    return dto;
  }
}
